import SearchConfig from "@/layout/header/searchBar/model/search/SearchConfig";
import ModuleSearchConfig from "@/layout/header/searchBar/model/search/ModuleSearchConfig";
import InputConfig from "@/layout/header/searchBar/model/search/input/InputConfig";
import ResultConfig from "@/layout/header/searchBar/model/search/result/ResultConfig";
import ColumnConfig from "@/layout/header/searchBar/model/search/result/ColumnConfig";

// -----------------------------------------------------------------------------
// Configurations des recherches HACCP
// -----------------------------------------------------------------------------

const HACCP_SEARCHES = new ModuleSearchConfig("haccp", [
  // Recherche livraisons
  new SearchConfig(
    "deliveries",
    "delivery",
    "HACCP_LIVRAISON_VISU",
    new InputConfig(false, 1),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("deliveryId"),
      new ColumnConfig("date"),
    ]),
  ),
  // Recherche cuissons de produits
  new SearchConfig(
    "cookings",
    "cooking",
    "HACCP_COOKING_VISU",
    new InputConfig(false, 5),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("batchNumber", true),
      new ColumnConfig("date"),
    ]),
  ),
  // Recherche refroidissements de produits
  new SearchConfig(
    "coolings",
    "cooling",
    "HACCP_REMISE_EN_TEMP_COOLING_VISU",
    new InputConfig(false, 5),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("batchNumber", true),
      new ColumnConfig("date"),
    ]),
  ),
  // Recherche surgelations de produits
  new SearchConfig(
    "freezings",
    "freezing",
    "HACCP_FREEZING_VISU",
    new InputConfig(false, 5),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("batchNumber", true),
      new ColumnConfig("date"),
    ]),
  ),
  // Recherche remises en T° de produits
  new SearchConfig(
    "rethermalizations",
    "rethermalization",
    "HACCP_REMISE_EN_TEMP_VISU",
    new InputConfig(false, 5),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("batchNumber", true),
      new ColumnConfig("date"),
    ]),
  ),
  // Recherche mises sous vide
  new SearchConfig(
    "vacuumSeals",
    "vacuumpacking",
    "HACCP_SOUSVIDE_VISU",
    new InputConfig(false, 5),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("batchNumber", true),
      new ColumnConfig("date"),
    ]),
  ),
  // Recherche traçabilité productions
  new SearchConfig(
    "productionsTraceability",
    "productiontraceability",
    "HACCP_TRACAPRODUCTION_VISU",
    new InputConfig(false, 5),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("batchNumber", true),
      new ColumnConfig("date"),
    ]),
  ),
  // Recherche tracabilité
  new SearchConfig(
    "traceability",
    "traceability",
    "HACCP_TRACABILITE_VISU",
    new InputConfig(false, 5),
    new ResultConfig([
      new ColumnConfig("domain"),
      new ColumnConfig("site"),
      new ColumnConfig("batchNumber", true),
      new ColumnConfig("date"),
      new ColumnConfig("product"),
    ]),
  ),
]);

export default HACCP_SEARCHES;
